module.exports = __webpack_public_path__ + "img/1c.18ce3b20.svg";